import React from "react";

import { useTranslation } from "react-i18next";

import { GoalDistributionTeamSection } from ".";
import { observer } from "mobx-react";
import { IGoalDistribution } from "@data-types/sport-stats/SportStatsTypes";
import { Team, Tournament } from "@gp/models";

export default observer(function GoalDistribution(props: {
	title: string;
	data: IGoalDistribution;
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) {
	const { t } = useTranslation();

	if (!props.data) return null;

	return (
		<div className="event__content">
			<div className="statistics__card">
				<div className="statistics__header">
					<span className="statistics__title">{t(props.title)}</span>
				</div>
				<div className="statistics__body">
					{props.data?.homeTeam && (
						<GoalDistributionTeamSection
							teamData={props.data?.homeTeam}
							mainTeam={props.homeTeam}
							opponentTeam={props.awayTeam}
							label={t("EVENT.OFFER.COMPETITOR_HOME")}
							tournament={props.tournament}
						/>
					)}
					{props.data?.awayTeam && (
						<GoalDistributionTeamSection
							teamData={props.data.awayTeam}
							mainTeam={props.awayTeam}
							opponentTeam={props.homeTeam}
							label={t("EVENT.OFFER.COMPETITOR_AWAY")}
							tournament={props.tournament}
						/>
					)}
				</div>
			</div>
		</div>
	);
});
